import { Component , HostListener, } from '@angular/core';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { HttpClient, HttpClientModule, HttpHeaders, } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environments';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [CommonModule, FormsModule, IconsFreeToolsComponent,TranslateModule],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.css'
})
export class FeedbackComponent {
  form_message: any;
  form_email: any;

  eFsubIF: boolean = false;
  color: string = 'black';
  dangerAlerts;
  showfeedbackloader: boolean = false;
  eFsubText2: any;
  ifsub: boolean = false;
  stars: number[] = [1, 2, 3, 4, 5];
  count = 5;

  constructor(
    private https: HttpClient, private translate: TranslateService,
    public languageService: LanguageService
  ) {
    this.translate.setDefaultLang('en');
  }

  countStar(star) {
    this.selectedValue = star;

  }

  public eFormSubmission(event: any) {
    event.preventDefault();
    this.eFsubIF = false
    $("#eFsubText2").hide();
    this.form_email = $('#form_email').val();
    this.form_message = $('#form_message').val();
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if (this.form_message.length === 0) {

      // this.dangerAlerts = 'Please provide the required fields';
      this.translate.get('Feedback-page.alert').subscribe((res: string) => {
        this.dangerAlerts = res;
      });
      $('#form_message').val('').css("border-color", "red");
      this.ifsub = true
      $("#dangerAlerts").show();
      setTimeout(function () {
        $("#dangerAlerts").hide();
        $('#form_message').css("border-color", "#08ba9c");
        this.ifsub = false
      }, 3000);
    }
    else {
      this.showfeedbackloader = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.https.post(environment.API_URL + '/api/feedbackForm', { 'email': this.form_email, 'comment': this.form_message, 'page_name': "home", 'emotion': this.selectedValue }, { headers }).subscribe(
        (response) => {
          this.showfeedbackloader = false

          // this.eFsubText2 = 'Form Submitted Successfully!';
          this.translate.get('Feedback-page.Form-Submitted').subscribe((res: string) => {
            this.eFsubText2 = res;
          });
          this.eFsubIF = true
          $("#eFsubText2").show();
          setTimeout(function () {
            $("#eFsubText2").hide();

            this.eFsubIF = false
          }, 3000);
          $('#form_email').val('').css("border-color", "#08ba9c");
          $('#form_message').val('').css("border-color", "#08ba9c");
        },
        (error) => {
          // console.error(error);
        }
      );

    }
  }

  checkMail() {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    this.form_email = $('#form_email').val();
    if (
      reg.test(this.form_email) === false
    ) {
      this.color = '#721c24';
      // this.dangerAlerts = 'Please provide correct Email';
      this.translate.get('Feedback-page.alert-correct-Email').subscribe((res: string) => {
        this.dangerAlerts = res;
      });
      $('#form_email').val('').css("border-color", "red");
      this.ifsub = true
      $("#dangerAlerts").show();
      setTimeout(function () {
        $("#dangerAlerts").hide();
        $('#form_email').css("border-color", "#08ba9c");
        this.ifsub = false
      }, 3000);
    }
  }


  clearfeedbackform() {
    this.selectedValue = 0;
    $('#form_email').val('').css("border-color", "#e7e7ec");
    $('#form_message').val('').css("border-color", "#e7e7ec");
  }



  selectedValue = 0;


  private getIsHalf(event: MouseEvent): boolean {
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    return event.clientX < rect.left + rect.width / 2;
  }


  // SCROL
    shouldShowButton: boolean = false;
    @HostListener('window:scroll', [])
    onWindowScroll() {
      if (window.pageYOffset > 200) {
        this.shouldShowButton = true;
      } else {
        this.shouldShowButton = false;
      }
    }
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
     public ngAfterViewInit(): void {
       $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
          $('#scroll-to-top').fadeIn('slow');
        } else {
          $('#scroll-to-top').fadeOut('slow');
        }
      });
      $('#scroll-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 700);
        return false;
      });
     }
  
}
